import apiRewardSearchList from '@/api/trainer-result'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getRewardSearchListStart: '[reward search list] Get reward search list start',
  getRewardSearchListSuccess:
    '[reward search list] Get reward search list success',
  getRewardSearchListFailure:
    '[reward search list] Get reward search list failure',
}

export const actionTypes = {
  getRewardSearchList: '[reward search list] Get reward search list',
}

const mutations = {
  [mutationTypes.getRewardSearchListStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getRewardSearchListSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getRewardSearchListFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getRewardSearchList](context, {params}) {
    context.commit(mutationTypes.getRewardSearchListStart)
    return new Promise((resolve) => {
      apiRewardSearchList
        .getRewardSearchList(params)
        .then((response) => {
          context.commit(
            mutationTypes.getRewardSearchListSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getRewardSearchListFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
